<section class="login-wrap mtb-40">
  @if (!error()) {
    <div class="login-box">
      <div class="login-box-inner">
        <div class="p-grid">
          <div class="p-col-12">
            <div class="logo-wrapper" routerLink="/admin">
              <h3>NEXO<span>.</span></h3>
            </div>
          </div>
        </div>
        @if (loginError()) {
          <div class="p-grid">
            <div class="p-col-12">
              <div class="alert alert-danger">
                {{loginError()}}
              </div>
            </div>
          </div>
        }
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <div class="p-fluid">
            <div class="p-field">
              <input type="text" pInputText formControlName="username" class="form-control" placeholder="Username"
                required>
              @if (username.invalid && (username.dirty || username.touched)) {
                <div class="error">
                  @if (username.errors) {
                    <div>
                      Username e neccessario.
                    </div>
                  }
                </div>
              }
            </div>
            <div class="p-field">
              <input type="password" pInputText formControlName="password" class="form-control" placeholder="Password"
                required>
              @if (password.invalid && (password.dirty || password.touched)) {
                <div class="error">
                  @if (password.errors) {
                    <div>
                      Password e neccessario.
                    </div>
                  }
                </div>
              }
            </div>
            <div class="p-field">
              <button pButton pRipple label="login" class="p-button p-button-primary btn-block"
              [disabled]="!formValid()"></button>
            </div>
          </div>
        </form>
      </div>
      @if (error()) {
        <div class="service-error">
          <h1>{{error().errorTitle}}</h1>
          <h3>{{error().errorDesc}}</h3>
        </div>
      }
    </div>
  }
</section>